const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '附件',
        },
    },
    {
        component: 'file-list',
        options: {
          groupId: '',
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '确定中标人',
        },
    },
    {
        component: 'ZlmNormalDetailList',
        options: {
            data: {},
        },
    },
    // {
    //     component: 'ZlmTitle',
    //     options: {
    //         size: 'medium',
    //         text: '审核记录',
    //     },
    // },
    // {
    //     component: 'ZlmTabDetail',
    //     options: {
    //         title: '记录',
    //         data: [],
    //     },
    // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')
const { getValue } = require('../enum')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/dbOverview`, {
                bdGuid: this.$route.query.id,
                ggBdGuid: this.$route.query.ggBDGuid,
            }, { showLoading: true }).then((res) => {
                this.getZbrDetail(res.data)
            })
        },
        getZbrDetail(row) {
            this.$request.post(`/transformToAfter/app/determine/bid/zbrInfoView`, {
                bdGuid: this.$route.query.id,
                guid: row.ztbConditionGuid,
            }).then((res) => {
                if (res.data && res.data.rows) {
                    this.config[3].options.groupId = res.data.rows.attachFileGuid
                    const rows = res.data.rows
                    this.config[1].options.data = {
                        '标段名称': rows.bdName,
                        '标段编号': rows.bdBH,
                        '项目类型': getProjectTypeName(row.xmLeiXing),
                        '采购方式': getPurchaseTypeName(rows.cgFangShi),
                        '报价供应商': rows.gysCount,
                        '候选供应商': rows.hxgysnum,
                        '授标形式': getValue('sbxingshi', rows.sbxingshi),
                        '变更次数': row.isBg,
                        '备注': rows.beizhu,
                    }
                    if (rows.zbrList && rows.zbrList.length > 0) {
                        this.config[5].options.data = rows.zbrList.map((t) => ({
                            '中标候选人': t.tbrName,
                            '是否中标': t.isZhongBiao ? '是' : '否',
                            '中标金额（元）': t.zhongBiaoJia,
                        }))
                    }
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
